<template>
  <div class="page-title-wrapper">
    <div class="page-title-left">
      <h1 class="page-title">{{ title }}</h1>
      <p v-if="description" class="page-description">{{ description }}</p>
    </div>
    <div class="page-title-actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
import { onMounted, watch } from 'vue'

export default {
  name: 'PageTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    appName: {
      type: String,
      default: 'SellHub'
    }
  },
  setup(props) {
    const setDocumentTitle = () => {
      if (typeof document !== 'undefined') {
        document.title = props.title ? `${props.title} | ${props.appName}` : props.appName
      }
    }

    onMounted(setDocumentTitle)
    watch(() => props.title, setDocumentTitle)

    return {}
  }
}
</script>

<style scoped>
.page-title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}
.page-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
}
.page-description {
  margin: 4px 0 0 0;
  color: #6b7280;
  font-size: 0.95rem;
}
.page-title-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
@media (max-width: 768px) {
  .page-title-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }
  .page-title-actions {
    width: 100%;
  }
}
</style>


